import {Button, ButtonGroup} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {useState} from 'react';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface ConfirmUnsavedGeneralChangesDialogProps extends TestIdProps {
  onConfirm: () => Promise<void>;
  onDecline: () => void;
}

export function ConfirmUnsavedGeneralChangesDialog(props: ConfirmUnsavedGeneralChangesDialogProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await props.onConfirm();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <VStack spacing={4}>
      <Text>{i18n.t('page.advertisement.labels.unsavedGeneralAttributesText')}</Text>
      <ButtonGroup align="right">
        <Button
          variant="secondary"
          onClick={props.onDecline}
          isDisabled={isSubmitting}
          title={i18n.t('general.actions.cancel')}
          data-testid={suffixTestId('decline', props)}
        />
        <Button
          variant="primary"
          onClick={handleConfirm}
          isLoading={isSubmitting}
          title={i18n.t('general.actions.saveAndContinue')}
          data-testid={suffixTestId('confirm', props)}
        />
      </ButtonGroup>
    </VStack>
  );
}
